import { render, staticRenderFns } from "./ReagendarFormacao.vue?vue&type=template&id=a0fe7ffc"
import script from "./ReagendarFormacao.vue?vue&type=script&lang=js"
export * from "./ReagendarFormacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports